<template>
  <div class="consultors">
    <v-img :src="header.bgImage" class="second-layout second-layout-background">
      <v-row class="header" no-gutters>
        <v-col cols="12" lg="5" md="6" sm="9">
          <h1 class="display-3 header-title">
            Ajude a eureciclo na missão de construir um mundo mais sustentável
            valorizando a reciclagem
          </h1>
          <p class="headline description mb-md-8 white--text">
            O programa de consultores da eureciclo tem como objetivo multiplicar
            a nossa solução, permitindo que mais pessoas e empresas contribuam
            para aumentar a taxa de reciclagem no Brasil. E você ainda ganha
            comissões por cada venda que realizar!
          </p>
          <v-btn
            v-scroll-to="'#form-consultors'"
            rounded
            large
            class="mb-2"
            @click="scrollToForm()"
          >
            QUERO SER UM CONSULTOR
          </v-btn>
        </v-col>
      </v-row>
    </v-img>
    <div class="sectionfour">
      <highlight-container
        title="Quem pode ser um <span class='text-green'>consultor eureciclo?</span>"
        odd
        class="py-md-10"
      >
        <v-row class="whocanbe">
          <v-col
            v-for="(item, i) in whocanbe"
            :key="i"
            align="center"
            :cols="isMobile && 6"
          >
            <img :src="item.image" :alt="item.text" contain /><br />
            <p class="text-body">{{ item.text }}</p>
          </v-col>
        </v-row>
        <div></div>
      </highlight-container>
    </div>
    <highlight-container
      title="Vantagens de ser um <span class='text-green'>consultor eureciclo</span>"
      even
      class="sectiontwo pa-0 py-md-10"
    >
      <Benefits
        :data="advantages"
        event-category="carrossel-team"
        :event-index="0"
      />
    </highlight-container>
    <highlight-container
      title="Confira o nosso time de consultores<br><span class='text-green'>que sorriem em todo Brasil!</span>"
      odd
      class="sectionthree py-md-10"
    >
      <v-row class="consultors-section" justify="center">
        <v-col
          v-for="(testimonial, i) in consultors.testimonials"
          :key="i"
          class="testimonial d-flex align-stretch"
          :class="testimonial.url && 'with-link'"
          :cols="isMobile ? 12 : 6"
          @click="
            testimonial.url &&
              openConsultorLink(testimonial.brand, testimonial.url)
          "
        >
          <div class="content">
            <div class="consultor-testimonial">
              <p>
                {{ testimonial.text }}
              </p>
            </div>
            <div class="consultor-info">
              <div class="consultor-avatar">
                <v-img
                  class="avatar-image"
                  :src="testimonial.avatar"
                  :alt="testimonial.name"
                  width="100"
                  height="100"
                />
              </div>
              <div class="consultor-details">
                <h3>
                  {{ testimonial.name }}
                </h3>
                <h3 v-if="!testimonial.image">
                  {{ testimonial.companyName }}
                </h3>
                <v-img
                  v-if="testimonial.image"
                  class="consultor-logo"
                  :src="testimonial.image"
                  :alt="testimonial.name"
                />
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="pa-0 ma-0" cols="12">
          <v-row class="pa-0 ma-0">
            <v-col
              v-for="brand in consultors.brands"
              :key="brand.title"
              class="only-logo"
              align="center"
              :cols="isMobile && 12"
            >
              <div class="content">
                <v-img
                  class="consultor-logo"
                  :src="brand.image"
                  :alt="brand.title"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </highlight-container>
    <div id="form-consultors" class="sectionfive">
      <highlight-container
        title="Quer se tornar um <span class='text-green'>consultor eureciclo?</span>"
        subtitle="Se candidatar para parceria é fácil, basta preencher o formulário abaixo."
        even
        class="py-md-10"
      >
        <ConsultorsContact />
      </highlight-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Consultors',
  metaInfo: {
    title: 'Consultores',
  },
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    Benefits: () => import('@/components/Benefits.vue'),
    ConsultorsContact: () => import('@/components/Forms/ConsultorsContact.vue'),
  },
  data: () => ({
    header: {
      bgImage: require('@/assets/images/consultors/header.png'),
    },
    advantages: [
      {
        title: 'Treinamento e suporte',
        image: require('@/assets/images/consultors/advantage1.png'),
        text:
          'Tenha acesso a diferentes treinamentos e cursos oferecidos pelos nossos especialistas que estão preparados para trabalhar em parceria, oferecendo ferramentas e mantendo nossos consultores atualizados a respeito das legislações de logística reversa.',
      },
      {
        title: 'Marketing positivo e transparente',
        image: require('@/assets/images/consultors/advantage2.jpg'),
        text:
          'Os consultores passam a fazer parte de um movimento por um mundo mais sustentável, garantindo uma solução de logística reversa com resultados comprovados. Terão a oportunidade de divulgar a marca no site da eureciclo, além de receberem conteúdos, e somar-se a milhares de consumidores e outras empresas engajadas em nossas redes sociais.',
      },
      {
        title: 'Comissionamento ao consultor e desconto aos clientes',
        image: require('@/assets/images/consultors/advantage3.jpg'),
        text:
          'Ganhe comissionamento por cliente que aderir a solução eureciclo, possíveis bônus por renovações e ainda  forneça um desconto exclusivo a partir de 10% aos seus clientes.',
      },
    ],
    consultors: {
      testimonials: [
        {
          name: 'Rodrigo Franco',
          brand: 'FrancoAmb',
          text:
            'A parceria da FrancoAmb com a Eureciclo é muito mais do que apenas o crescimento das duas empresas, mas é na verdade a junção de dois ideais. Quando conseguimos novos parceiros com o selo Eureciclo isso significa que mais cooperativas de  famílias que muitas vezes estão em situação de vulnerabilidade possam ser beneficiadas pelo trabalho ambiental que desenvolvem, ou seja, esta parceria visa a melhoria da vida das pessoas e a proteção do meio ambiente, por meio do incentivo da reciclagem.',
          avatar: require('@/assets/images/consultors/avatar-francoamb.png'),
          image: require('@/assets/images/consultors/logo-francoamb.png'),
          url: 'https://francoamb.com.br/',
        },
        {
          name: 'Daniel Almeida',
          brand: 'maxce',
          text:
            'Trabalhar em parceria com a Eureciclo é uma grande oportunidade de oferecer uma solução prática e viável as empresas comprometidas com o meio ambiente. Participar desta quebra de paradigma sobre a gestão dos resíduos e a reciclagem é um desafio que não podemos deixar de contribuir e apoiar. A conscientização ambiental vem crescendo a cada ano e as empresas que vivenciarem esta experiência estão mais preparadas para atender a demanda de um cliente mais exigente a cada dia.',
          avatar: require('@/assets/images/consultors/avatar-maxce.png'),
          image: require('@/assets/images/consultors/logo-maxce.png'),
          url: 'https://www.linkedin.com/company/max-consultoria-empresarial/',
        },
        {
          name: 'Fernanda Schneider Thebit',
          brand: 'Fernanda Schneider Thebit',
          text:
            'Cada dia mais fala-se de consumo consciente e preservação ambiental e é nesse cenário que o selo eureciclo vem auxiliando empresas a firmar seus compromissos com a reciclagem. Mais do que se adequar a legislação vigente, nossos clientes investem na cadeia de reciclagem, inclusive por meio da remuneração direta dos operadores de triagem. Como consultora é um prazer conectar empresas à essa solução que é social, ambiental e economicamente sustentável de forma transparente, prática e acessível.',
          avatar: require('@/assets/images/consultors/avatar-fernandathebit.png'),
          companyName: 'Consutoria',
          url: 'https://www.linkedin.com/in/fernanda-schneider-thebit/',
        },
        {
          name: 'Eleine Bélaváry',
          brand: 'connexion',
          text:
            'Conscientizar as franquias sobre o impacto de suas embalagens representa um grande desafio, ao mesmo tempo em que atribui muito significado à minha atuação profissional. Sorrir em parceria com a eureciclo por um planeta social e ambientalmente mais justo e sustentável é um super propósito!',
          avatar: require('@/assets/images/consultors/avatar-eleinebelavary.png'),
          image: require('@/assets/images/consultors/logo-connexion.png'),
          url: 'https://www.instagram.com/connexion.sustentavel/',
        },
        {
          name: '',
          brand: 'Rai Jairo',
          text:
            'Consolidar a parceria com a Eureciclo com toda certeza é uma imensa satisfação para nós e um grande passo para proporcionar uma mudança efetiva do cenário ambiental atual, buscando facilitar o processo para que as empresas possam aderir a esse movimento e inovar em seus processos referentes a esta área. As questões ambientais estão em evidencia e ter ações positivas coerentes com certeza resultará em um impacto socioambiental desejável para todos.',
          avatar: require('@/assets/images/consultors/avatar-rai.png'),
          image: require('@/assets/images/consultors/logo-raijairo.png'),
          // url: 'https://www.instagram.com/connexion.sustentavel/',
        },
      ],
      brands: [
        {
          title: 'Rai Jairo',
          image: require('@/assets/images/consultors/consultor4.png'),
        },
        {
          title: 'Connexion',
          image: require('@/assets/images/consultors/consultor3.png'),
        },
        {
          title: 'Inova Nature',
          image: require('@/assets/images/consultors/consultor2.png'),
        },
        {
          title: 'Cambuci',
          image: require('@/assets/images/consultors/logo-francoamb.png'),
        },
      ],
    },
    whocanbe: [
      {
        image: require('@/assets/images/consultors/type1.png'),
        text: 'Empresas de Consultoria Ambiental',
      },
      {
        image: require('@/assets/images/consultors/type2.png'),
        text: 'Empresas de Design de Embalagens',
      },
      {
        image: require('@/assets/images/consultors/type3.png'),
        text: 'Empresas de Gestão de Resíduos',
      },
      {
        image: require('@/assets/images/consultors/type4.png'),
        text: 'Profissionais PJ da área ambiental',
      },
      {
        image: require('@/assets/images/consultors/type5.png'),
        text: 'Qualquer empresa de economia circular',
      },
    ],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    currentPersona() {
      return {
        id: 4,
        name: 'Consultores',
        hrefButton: null,
        textButton: 'QUERO SER UM CONSULTOR',
        eventAnalytics: 'quero-ser-um-consultor',
        callback: () => {
          this.scrollToForm('navbar');
        },
      };
    },
  },
  beforeMount() {
    this.$store.commit('persona/updateSelected', this.currentPersona);
  },
  methods: {
    scrollToForm(origin = 'banner') {
      //  Calculo para remover o tamanho da barra de navegação
      this.$vuetify.goTo(
        document.getElementById('form-consultors').offsetTop -
          document.getElementById('navbar').offsetHeight,
      );

      this.$analytics('consultores', 'click', origin);
    },
    openConsultorLink(brand, url) {
      window.open(url);

      this.$analytics('consultores', 'click', brand);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.header
  margin-top: 100px
  @media screen and (max-width: $sm)
    margin-top: 50px
  @media screen and (max-width: $xs)
    margin-top: 0px

.header-title
  color: $primary
  font-size: 2em !important
  line-height: 1.3em !important
  @media screen and (max-width: $sm)
    font-size: 2em !important
  @media screen and (max-width: $xs)
    font-size: 1.3em !important

.description
  font-weight: 500
  padding-top: 2vw
  font-family: "Proxima Nova", sans-serif !important
  font-size: 1.5vw !important
  @media screen and (max-width: $sm)
    font-size: 1.7em !important
  @media screen and (max-width: $xs)
    font-size: 1em !important
    line-height: 1.25em

.new-color
  .header-title,
  .description
    font-family: 'metropolismedium' !important
    font-weight: normal
  .header-title
    color: $secondary
</style>

<style lang="sass">
@import '@/styles/util'
@import '@/styles/style'

.consultors
  .text-green
    color: $primary !important

  ul
    color: rgba(0, 0, 0, 0.87)

  .second-layout
    .v-image__image.v-image__image--cover:before
      content: ''
      display: block
      width: 100%
      height: 100%
      position: absolute
      z-index: 9
      background-color: rgba(10,10,10,0.52)

  .sectiontwo
    .v-window__prev, .v-window__next
      button
        background: transparent !important

  .sectionthree
    .consultors-section
      .only-logo
        .content
          padding: 24px
          display: flex
          justify-content: center
          align-items: center
          background: #fff
          min-height: 187px

          .consultor-logo
            max-width: 168px

    .testimonial
      font-family: "Gotham Rounded Light", serif

      &.with-link
        cursor: pointer

      .content
        padding: 24px
        display: flex
        flex-direction: column
        justify-content: space-between
        background: #fff
        min-height: 356px

        .consultor-testimonial
          margin-bottom: 16px

          p
            margin-bottom: 0

        .consultor-info
          display: flex

          .consultor-details
            padding-left: 16px

            .consultor-logo
              max-width: 130px

          .consultor-avatar
            .avatar-image
              border-radius: 100%

  .sectionfour
    .whocanbe
      .text-body
        text-align: center
      img
        max-width: 100px

  .sectionfive
    .text-body
      text-align: center !important

.new-color
  .consultors
    .text-green
      color: #26d07c !important
    ul
      color: rgba(0, 48, 54, 0.87)
    .sectionthree
      .testimonial
        font-family: 'metropolisregular'
        .content
          .consultor-testimonial
            p
              font-size: 19px
              font-weight: normal
</style>
